import React from "react";
export * from "./i18link";
export * from "./redirect";
export * from "./hoc";

export const UmLink = () => <span>User Manual</span>